import React, { useEffect } from "react";
import { BeatLoader } from "react-spinners";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UsersOrg } from "../../api/Actions/SsoB3/SsoB3";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import setAuthorizationHeaders from "../../api/Config/setAuthorizationHeaders";
import { DeleteReduxDataLogin } from "../../api/Actions/SsoB3/DeleteReduxDataLogin";

const SelectOrg = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [SelectedOrg, setSelectedOrg] = useState("");
  const [OrganizationList, setOrganizationList] = useState("");
  const [ErrorMessage, setErrorMessage] = useState("");
  const [Loading, setLoading] = useState(true);

  const LoginOtp = useSelector((state) => state.UsersLogin.UsersOtp);
  const LoginOrg = useSelector((state) => state.UsersLogin.UsersOrg);
  const loginData = useSelector((state) => state.UsersLogin.UsersLogin);
  const loginOtp = useSelector((state) => state.UsersLogin.UsersOtp);

  const HandleBackButton = () => {
    dispatch(DeleteReduxDataLogin());
    dispatch({
      type: "set",
      loginProcess: "user",
    });
  };

  const handleSelect = (e) => {
    setSelectedOrg(e.target.value);
  };

  const handleSubmit = () => {
    // handle submit select organization
    if (SelectedOrg === "") {
      setErrorMessage("Please Select Organization");
    } else {
      setErrorMessage("");
      dispatch({ type: "set", login: true });
      dispatch({ type: "set", menu: "" });
      localStorage.setItem("orgUuid", SelectedOrg.value);
      navigate("/");
    }
  };

  useEffect(() => {
    const userId = localStorage.getItem("identityUuid");
    // if (window.location.origin.includes("localhost"))
    //   setAuthorizationHeaders(
    //     loginData?.data?.sessionToken ||
    //       loginOtp?.data?.sessionToken ||
    //       localStorage.getItem("sessionToken")
    //   );
    const param = {
      domain: localStorage.getItem("domain"),
    };
    dispatch(UsersOrg(userId, param));
  }, []);

  useEffect(() => {
    if (LoginOrg && LoginOrg.data.organization.rows) {
      let options = [];
      LoginOrg.data.organization.rows.forEach((data) => {
        let optionData = { value: data.orgUuid, label: data.name };
        options.push(optionData);
      });
      setOrganizationList(options);
    } else {
    }
    setTimeout(() => {
      setLoading(false);
    }, 3000);
    clearTimeout();
  }, [LoginOrg]);

  return (
    <>
      <div className="my-auto">
        <div className="flex flex-col w-4/5 lg:w-4/6 mx-auto">
          <div className="w-full">
            <p className="my-10 poppins-800 text-white tracking-lg">Select Organization</p>
          </div>
          <div className="flex flex-row items-center mb-8">
            {Loading ? (
              <div className="flex flex-col ">
                <BeatLoader className="mx-auto my-auto" color="#FFFFFF" size={8} />
                <p className="text-white my-4 text-sm">Please wait.. Do not refresh or close your browser.</p>
              </div>
            ) : (
              <>
                {LoginOrg && LoginOrg.data ? (
                  <Select
                    value={SelectedOrg}
                    onChange={(selected) => setSelectedOrg(selected)}
                    options={OrganizationList}
                    maxMenuHeight={100}
                    placeholder="Select Organization"
                    className="text-black w-full"
                  ></Select>
                ) : (
                  ""
                )}
              </>
            )}
          </div>
          <div className="flex flex-col items-center justify-between">
            {/* <button
              onClick={(e) => HandleBackButton()}
              className="my-3 text-main-blue text-sm rad w-2/5 h-14 bg-white rounded-md poppins-800 text-blue-b3 tracking-widest hover:bg-slate-200"
            >
              BACK
            </button> */}
            <button
              onClick={(e) => handleSubmit()}
              className="my-3 mx-auto text-main-blue text-sm rad w-2/5 h-14 bg-white rounded-md poppins-800 text-blue-b3 tracking-widest hover:bg-slate-200"
            >
              CONTINUE
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SelectOrg;
